export const COMMONCONSTANTS = {
    COORDS: 'COORDS',
    SUCCESS_FETCHCART: "SUCCESS_FETCHCART"
}